<script>
export default {
    name: 'IlluOutilsPedagogiques',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-outils-pedagogiques"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M16 44.5V48h3.5v3.5L9 55l2.5-10.499L16 44.5zm6.206-10.606l7.712 7.384-8.418 8.26V46H18v-3.5l-4.482.001 8.688-8.607zM41.64 14.64l7.639 7.639-7.756 7.611-7.768-7.438 7.885-7.812zm3.025-2.988a4 4 0 015.484.163l1.996 1.996.15.16a4 4 0 01-.15 5.497l-1.352 1.325-7.646-7.646 1.358-1.345z"
                :fill="primaryColor"
                class="primary-color"
            />
            <path
                d="M11.828 19.495l32.677 32.677a4 4 0 005.657 0l2.01-2.01a4 4 0 000-5.657L19.495 11.828a4 4 0 00-5.657 0l-2.01 2.01a4 4 0 000 5.657z"
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linejoin="round"
            />
            <path
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
                d="M27.879 29.121l4.242-4.242M31.879 33.121l4.242-4.242M35.879 37.121l4.242-4.242M39.879 41.121l4.242-4.242M43.879 45.121l4.242-4.242M23.879 25.121l4.242-4.242M19.879 21.121l4.242-4.242M15.879 17.121l4.242-4.242"
            />
        </g>
    </svg>
</template>
